import { input, computed, Component, ChangeDetectionStrategy } from '@angular/core';

import { ProgressSpinner } from '@/app/shared/components/ui/progress-spinner';

import { ButtonIconSize, ButtonIconColor, ButtonIconVariant } from './types';

import { BooleanTransformer } from '@/app/shared/utils';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[appButtonIcon]',
  standalone: true,
  templateUrl: './button-icon.html',
  styleUrl: './button-icon.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressSpinner],
  host: {
    class: 'button-icon',
    '[class]': '[variant(), `size-${size()}`, `color-${color()}`]',
    '[class.disabled]': '!!disabledAttribute()',
  },
})
export class ButtonIcon {
  public variant = input<ButtonIconVariant>('default');

  public size = input<ButtonIconSize>('default');

  public color = input<ButtonIconColor>('default');

  public loading = input<boolean>(false);

  public disabled = input(false, { transform: BooleanTransformer });

  public disabledAttribute = computed(() => (!this.loading() && !this.disabled() ? null : true));
}
